module.exports = __webpack_public_path__ + "static/media/buy_req_rent_3.47d70922.jpg";